import React from 'react';
import {motion} from 'framer-motion';
import {useInView} from 'framer-motion';
import {useRef} from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiShoppingBag, FiBook, FiCoffee, FiCalendar, FiUsers, FiTrendingUp, FiTarget, FiAward} = FiIcons;

const Solutions = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, {once: true, margin: "-100px"});

  const solutions = [
    {
      icon: FiShoppingBag,
      title: "Einzelhandel & E-Commerce",
      description: "Automatisierte Bestellannahme und Kundenservice ohne manuellen Aufwand – KI übernimmt die telefonische Kundenkommunikation"
    },
    {
      icon: FiBook,
      title: "Buchhandlung & Warenwirtschaft",
      description: "Kunde bestellt ein Buch – KI übernimmt Kundenkommunikation und übergibt alle relevanten Daten an die Warenwirtschaft"
    },
    {
      icon: FiCoffee,
      title: "Gastronomie & Hotellerie",
      description: "Intelligente Tischreservierungen und Buchungsanfragen rund um die Uhr – automatisierte Gastronomieprozesse"
    },
    {
      icon: FiCalendar,
      title: "Zahnarztpraxis & Terminmanagement",
      description: "Vollautomatische Terminvereinbarungen und Patientenkommunikation für Arztpraxen und Dienstleister"
    },
    {
      icon: FiTarget,
      title: "Business Coach & Trainer Terminbuchung",
      description: "Intelligente Terminplanung für selbstständige Coaches, Berater und Trainer – automatisierte Kundenakquise und Terminkoordination"
    },
    {
      icon: FiAward,
      title: "Unternehmensberatung & Coaching",
      description: "KI-gestützte Erstberatung und Kundenqualifizierung für Berater, Personal Trainer und Business Coaches"
    },
    {
      icon: FiUsers,
      title: "Beratung & Lead-Qualifizierung",
      description: "Erste Kundenanfragen intelligent vorqualifizieren und weiterleiten – optimierte Vertriebsprozesse"
    },
    {
      icon: FiTrendingUp,
      title: "Digitaler Kundenservice",
      description: "24/7 Produktberatung und technischer Support für Online-Shops und Dienstleistungsunternehmen"
    }
  ];

  return (
    <section id="solutions" className="py-20 bg-white w-full" ref={ref}>
      <div className="container mx-auto px-6">
        <motion.div 
          initial={{opacity: 0, y: 50}} 
          animate={isInView ? {opacity: 1, y: 0} : {opacity: 0, y: 50}} 
          transition={{duration: 0.8}}
          className="max-w-6xl mx-auto"
        >
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-8">
              KI-Lösungen für dein Unternehmen
            </h2>
            <div className="w-24 h-1 bg-azure-600 mx-auto mb-12"></div>
            <p className="text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed mb-12">
              K³ macht deine Kundenkommunikation effizienter – ohne Programmierkenntnisse. Wir bringen moderne KI-Technologie in eine Sprache, die Unternehmer verstehen und sofort anwenden können.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {solutions.map((solution, index) => (
              <motion.div
                key={index}
                initial={{opacity: 0, y: 30}}
                animate={isInView ? {opacity: 1, y: 0} : {opacity: 0, y: 30}}
                transition={{duration: 0.6, delay: index * 0.1}}
                className="bg-gray-50 p-8 rounded-xl hover:shadow-lg transition-all duration-300 group"
              >
                <div className="flex items-center mb-4">
                  <SafeIcon 
                    icon={solution.icon} 
                    className="text-3xl text-azure-600 mr-4 group-hover:scale-110 transition-transform duration-300" 
                  />
                  <h3 className="text-xl font-semibold text-black">{solution.title}</h3>
                </div>
                <p className="text-gray-700 leading-relaxed">{solution.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Solutions;